export const size = window.innerWidth < 600 ? 50 : 80
export const rows = 6
export const cols = 7
